﻿export default {
  AIOrderForm: {
    text: '订单信息',
    upload: '上传附件',
    placehtext: '请填写订单信息！',
    placehsteps: '1. 支持图片、Excel、Word、PDF、聊天记录等粘贴 / 拖入 / 上传\n2. 支持中文/英文/混合格式\n3. 信息包含：发/收件人（姓名、电话、地址）和包裹（重量/尺寸）\n4. 点击提交，系统自动识别并生成订单\n5. 在AI订单列表确认 → 点击预测费用\n6. 选择渠道 → 支付 → 打印订单，完成发货',
    tuozhuaiwenjian: '将文件拖到此处，或',
    dianjishangchuan: '点击上传',
    zhichiduogewenjian: '支持图片、Excel、PDF格式，最多支持上传9个文件',
    ctrlvTip: '或按 Ctrl+V 粘贴文件',
    ctrlvSupport: '，支持 Ctrl+V 粘贴上传',
    submit: '提交',
    reset: '取消',
    uploadSuccess: '上传成功',
    uploadFail: '上传失败',
    warningTitle: '地址识别提醒',
    warningConfirm: '我知道了，去核对',
  },
  address: {
    addAddress: "新增地址",
    serialNumber: "序号",
    realname: "姓名",
    country: "国家/地区",
    province: "州/省",
    city: "城市",
    address1_2: "地址1/2",
    mobile: "手机号",
    zcode: "邮编",
    email: "邮箱",
    type: "类型",
    senderAddress: "发件人地址",
    recipientAddress: "收件人地址",
    operation: "操作",
    edit: "修改",
    delete: "删除",
    select: "选择",
    confirmDelete: "确认删除?",
    warmTips: "温馨提示",
    add: "新增地址",
    editAddress: "编辑地址",
    reset: "重置",
    query: "查询",
    addressType: "地址类型",
  },
  addressForm: {
    type: "类型",
    senderAddress: "发件人地址",
    recipientAddress: "收件人地址",
    realname: "姓名",
    company: "公司",
    country: "国家/地区",
    province: "州/省",
    city: "城市",
    zcode: "邮编",
    address1: "地址1",
    address2: "地址2",
    address3: "地址3",
    mobile: "手机号",
    email: "邮箱",
    setDefaultAddress: "设置成默认地址",
    submit: "提交",
    reset: "重置",
    placeholder: {
      selectType: "请选择类型",
      inputRealname: "请输入姓名",
      inputCompany: "请输入公司",
      selectCountry: "请选择国家",
      selectProvince: "请选择州/省",
      inputCity: "请输入城市",
      inputZcode: "请输入邮编",
      inputAddress1: "请输入地址1",
      inputAddress2: "请输入地址2",
      inputMobile: "请输入手机号",
      inputEmail: "请输入邮箱",
    },
    validate: {
      requiredType: "请选择类型",
      requiredRealname: "请输入姓名",
      requiredAddress1: "请输入地址1",
      requiredCountry: "请选择国家",
      requiredProvince: "请选择州省",
      requiredCity: "请输入城市",
      requiredZcode: "请输入邮编",
      requiredMobile: "请输入手机号",
    },
  },
  calc: {
    startCountry: "发货国家/地区",
    startZipCode: "发货邮编",
    destinationCountry: "收货国家/地区",
    destinationZipCode: "收货邮编",
    isResidential: "是否住宅地址?",
    unit: {
      lbIn: "磅/英寸",
      kgCm: "千克/厘米",
    },
    weight: {
      lb: "磅",
      oz: "盎司",
      ozL: "盎司 长",
    },
    dimension: {
      length: "长",
      width: "宽",
      height: "高",
    },
    packNum: "包裹数量",
    filter: {
      all: "全部",
      fedex: "联邦快递",
    },
    button: {
      getRates: "获取运费",
      reset: "重置",
    },
    table: {
      service: "服务类型",
      packageType: "包裹类型",
      rate: "运费",
      action: "操作",
    },
    validate: {
      requiredStartCountry: "请选择发货国家",
      requiredStartZipCode: "请输入发货邮编",
      requiredDestinationCountry: "请选择收货国家",
      requiredDestinationZipCode: "请输入收货邮编",
      requiredLb: "请输入重量",
      requiredLength: "请输入长",
      requiredWidth: "请输入宽",
      requiredHeight: "请输入高",
    },
    placeholder: {
      zipCode: "邮编",
    },
  },
  facilitator: {
    serialNumber: "序号",
    serviceProvider: "服务商",
    serviceProviderDesc: "服务商说明",
    title: "服务商列表", // 可选：页面标题文案
  },
  finance: {
    invoice: {
      serialNumber: "序号",
      orderNo: "订单号",
      waybillNo: "运单号",
      createTime: "创建时间",
      operation: "操作",
      viewInvoice: "查看发票",
      invoiceList: "发票列表",
      viewInvoiceTitle: "查看发票",
      pagination: {
        total: "共 {total} 条",
        perPage: "每页 {size} 条",
        page: "第 {current} 页",
      },
    },
    credit: {
      serialNumber: "序号",
      changeTime: "变更时间",
      changeMethod: "变更方式",
      changeAmount: "变更额度",
      amountBeforeChange: "变更前额度",
      amountAfterChange: "变更后额度",
      changeReason: "变更原因",
      deductionNote: "补扣说明",
      increase: "增加",
      deduction: "扣除",
      startDate: "开始日期",
      endDate: "结束日期",
      to: "至",
      placeholder: {
        selectChangeMethod: "请选择变更方式",
      },
      button: {
        query: "查询",
        reset: "重置",
        export: "导出",
      },
      title: "信用流水",
    },
    consumption: {
      serialNumber: "序号",
      time: "时间",
      type: "类型",
      amount: "金额",
      currentBalance: "当前余额",
      logisticsNo: "物流单号",
      deductionOrderNo: "补扣订单号",
      remark: "备注",
      deductionNote: "补扣说明",
      startDate: "开始日期",
      endDate: "结束日期",
      to: "至",
      typeOptions: {
        adminRecharge: "管理员充值",
        recharge: "充值",
        consumption: "消费",
        freightDeduction: "补扣运费",
        refund: "退款",
      },
      placeholder: {
        selectType: "请选择类型",
      },
      button: {
        query: "查询",
        reset: "重置",
        export: "导出",
      },
      title: "消费流水",
    },
    invoiceView: {
      viewInvoice: "查看发票",
    },
  },
  recharge: {
    title: "快递充值",
    balanceLabel: "当前打单余额",
    amountLabel: "充值金额",
    amountPlaceholder: "请输入充值金额",
    amountTip: "单笔充值金额 $1 ~ $50000，无手续费，实时到账",
    quick: "快捷金额",
    methodLabel: "支付方式",
    methodBalance: "余额",
    methodCard: "信用卡",
    methodWechat: "微信支付",
    methodAlipay: "支付宝",
    methodPaypal: "PayPal",
    confirmBtn: "确认充值",
    amountInvalid: "请输入正确的充值金额",
    amountMin: "单笔充值金额需大于等于 $1",
    amountMax: "单笔充值金额需小于等于 $50000",
    payTitle: "完成支付",
    payCreateShipment: "支付并创建运单",
    balanceAvailable: "可用余额",
    payNow: "立即支付",
    paying: "支付中",
    paySuccess: "充值成功",
    payFail: "支付失败，请重试",
    netErr: "网络异常，请稍后重试",
    loadingPay: "正在加载支付",
    creatingOrder: "正在生成充值订单",
    preparingPayment: "正在准备支付",
    orderRateRequired: "请先预估运费并选择物流渠道",
    scanWechatTip: "请用微信扫一扫完成支付",
    scanAlipayTip: "请用支付宝扫一扫完成支付",
    qrLeft: "支付码剩余",
    qrExpired: "二维码已过期，请重新生成",
    regenerate: "重新生成",
    waitingPay: "等待支付，请稍候",
    close: "关闭",
    cancel: "取消",
  },
  invoice: {
    invoice: {
      serialNumber: "序号",
      orderNo: "订单号",
      waybillNo: "运单号",
      createTime: "创建时间",
      operation: "操作",
      viewInvoice: "查看发票",
      orderInvoice: "订单发票",
      addressType: "地址类型",
      senderAddress: "发件人地址",
      recipientAddress: "收件人地址",
      placeholder: {
        selectAddressType: "请选择地址类型",
      },
      button: {
        query: "查询",
        reset: "重置",
      },
    },
    detail: {
      generatePdf: "发票下载",
      invoiceTips: "本发票必须使用英文填写。",
      proFormaInvoice: "形式发票",
      page: "页码",
      of: "共",
      exporter: "出口商：",
      taxId: "税务登记号：",
      contactName: "联系人姓名：",
      telephoneNo: "电话号码：",
      email: "电子邮箱：",
      companyNameAddress: "公司名称/地址",
      countryTerritory: "国家/地区：",
      partiesToTransaction: "交易相关方：",
      related: "关联方",
      nonRelated: "非关联方",
      shipDate: "发货日期：",
      airWaybillNo: "空运单号/追踪号",
      invoiceNo: "发票编号：",
      purchaseOrderNo: "采购订单号：",
      paymentTerms: "付款条件：",
      billOfLading: "提单",
      purposeOfShipment: "装运目的：",
      sold: "已售出",
      consignee: "收货人：",
      soldToImporter: "购买方/进口商（如与收货人不同）：",
      designatedBroker: "如本批货物有指定报关行，请提供联系信息。",
      nameOfBroker: "报关行名称",
      telNo: "电话",
      contactNameShort: "联系人姓名",
      dutiesAndTaxesPayableBy: "税费支付方",
      exporter: "出口商",
      consigneeShort: "收货人",
      other: "其他",
      ifOtherPleaseSpecify: "如选其他，请注明",
      noOfPackages: "包装数量",
      noOfUnits: "单位数量",
      netWeight: "净重",
      lbsKgs: "（磅/千克）",
      unitOfMeasure: "计量单位",
      descriptionOfGoods: "货物描述",
      harmonizedTariffNumber: "协调关税编号",
      countryTerrOfMfr: "生产国家/地区",
      unitValue: "单价",
      totalValue: "总价",
      totalPkgs: "总包装数",
      totalUnits: "总单位数",
      totalNetWeight: "总净重",
      totalGrossWeight: "总毛重",
      indicateLbsKgs: "（请注明磅/千克）",
      termsOfSale: "销售条款：",
      subtotal: "小计：",
      insurance: "保险费：",
      freight: "运费：",
      packing: "包装费：",
      handling: "手续费：",
      otherFee: "其他费用：",
      specialInstructions: "特殊说明：",
      declarationStatements: "声明条款：",
      declarationContent:
        "这些物品受美国政府管制，仅授权出口至本发票注明的最终目的国，供指定的最终收货人或最终用户使用。未经美国政府事先批准或除非符合美国法律法规的其他授权规定，不得将这些物品（无论是原装形式还是并入其他物品后）转售、转让或以其他方式处置给任何其他国家或任何非授权的最终收货人/最终用户。",
      declareTrueCorrect: "我声明本发票所载所有信息均真实准确。",
      originatorOrCompanyRep: "制单人或公司代表姓名（如代表公司或个人填写本发票）：",
      invoiceTotal: "发票总额：",
      currencyCode: "货币代码：",
      signatureTitleDate: "签名/职务/日期：",
      rev: "版本",
    },
  },
  layout: {
    index: {
      calculator: "计算器", // 弹窗标题
      close: "关闭", // 备用：计算器关闭按钮（按需使用）
    },
    side: {
      home: "首页",
      createDomesticWaybill: "新建国内快递面单",
      createInternationalWaybill: "新建国际快递面单",
      expressOrderManagement: "快递订单管理",
      expressAddressManagement: "快递地址管理",
      invoiceList: "发票列表",
      findStores: "查找门店",
      ltlOrderManagement: "LTL订单管理",
      orderList: "订单列表",
      ltlQuoteManagement: "LTL报价管理",
      onlineQuote: "在线报价",
      quoteList: "报价列表",
      fbaQuote: "FBA报价",
      ltlProductManagement: "LTL产品管理",
      ltlAddressManagement: "LTL地址管理",
      myFinance: "我的财务",
      expressConsumptionFlow: "快递消费流水",
      expressRecharge: "快递充值",
      ltlRechargeManagement: "LTL充值管理",
      ltlFinancialDetails: "LTL财务明细",
      ltlInvoiceManagement: "LTL发票管理",
      announcementList: "公告列表",
      myWorkOrder: "我的工单",
      serviceProviderList: "服务商列表",
      accountManagement: "账号管理",
      personalInfo: "个人信息",
      changePassword: "修改密码",
      // 注释中备用文案
      internationalOrder: "国际订单",
      financialManagement: "财务管理",
      creditFlow: "信用流水",
      memberCenter: "会员中心",
      calculator: "计算器",
      personalCenter: "个人中心",
      test: "测试",
      AIOrderForm: 'AI自动填单',
      AIOrderList: 'AI订单列表'
    },
    top: {
      printBalance: "打单余额：",
      ltlBalance: "LTL余额：",
      logOut: "退出登录",
      noNewNotifications: "暂无新通知消息~",
      newNotifications: "新通知消息", // 备用：通知标题
    },
  },
  stores: {
    pageTitle: "查找门店",
    pageSubtitle: "选择国家/地区并输入邮编，查找附近的 FedEx 与 UPS 门店",
    countryPlaceholder: "请选择国家/地区",
    countryRequired: "请选择国家/地区",
    countryLoadFailed: "国家/地区列表加载失败，请稍后重试",
    zipcodePlaceholder: "请输入邮编",
    zipcodeInvalid: "请输入正确的邮编（最多10位字母、数字、空格或连字符）",
    searchBtn: "查询",
    searching: "查询中...",
    fedexTitle: "FedEx 门店",
    upsTitle: "UPS 门店",
    weekHours: "一周营业时间",
    openAllDay: "全天营业",
    selfService247: "24/7 自助投递",
    noHours: "暂无营业时间",
    rest: "休息",
    services: "业务",
    fedexEmpty: "该区域暂无 FedEx 门店",
    upsEmpty: "该区域暂无 UPS 门店",
    initialTip: "请在上方选择国家/地区并输入邮编开始查询",
    notFoundTip: "未找到门店，换个邮编试试？",
    quickTry: "试试热门邮编：",
    errorPrefix: "查询失败：",
  },
  login: {
    index: {
      account: "账号",
      password: "密码",
      placeholder: {
        inputAccount: "请输入账号",
        inputPassword: "请输入密码",
      },
      registerAccount: "注册账号",
      login: "登录",
      forgetPassword: "忘记密码",
      accountLogin: "账号登录",
      tempLogin: "临时登录",
      requiredMessage: {
        account: "请输入账号",
        password: "请输入密码",
      },
      forgetPasswordTitle: "忘记密码",
      brandSlogan: "AI 原生物流操作系统",
      brandDesc: "让 AI 协助处理您的物流运营。",
      assistant247: "全天候 AI 运营助手",
      poweredByEva: "由 EVA 提供支持",
    },
    pass: {
      email: "邮箱",
      verificationCode: "验证码",
      newPassword: "新密码",
      confirmPassword: "确认密码",
      placeholder: {
        inputEmail: "请输入注册邮箱",
        inputCode: "请输入邮箱验证码",
        inputNewPassword: "请输入新密码（至少6位）",
        inputConfirmPassword: "请再次输入新密码",
      },
      getCode: "获取验证码",
      codeSent: "验证码已发送至您的邮箱。",
      sendingCode: "发送中...",
      getCodeCountdown: "重新获取({0})",
      submit: "重置密码",
      reset: "重置",
      resetSuccess: "密码重置成功，请使用新密码登录",
      requestFailed: "请求失败，请稍后重试",
      requiredMessage: {
        email: "请输入注册邮箱",
        captcha: "请输入邮箱验证码",
        newPassword: "请输入新密码",
        confirmPassword: "请再次输入新密码",
      },
      formatMessage: {
        email: "邮箱格式不正确",
        captcha: "验证码格式不正确",
        passwordLength: "密码不能少于6位",
        passwordNotMatch: "两次输入的密码不一致",
      },
    },
  },
  register: {
    account: "账号",
    phoneNumber: "手机号",
    password: "密码",
    confirmPassword: "确认密码",
    verificationCode: "验证码",
    getCode: "获取验证码",
    getCodeCountdown: "重新获取({0})",
    placeholder: {
      inputAccount: "请输入账号",
      inputEmail: "请输入邮箱",
      inputPhone: "请输入手机号",
      inputPassword: "请输入密码",
      inputConfirmPassword: "请输入确认密码",
      inputCode: "请输入验证码",
    },
    login: "登录",
    register: "注册",
    registerAccount: "注册账号", // 注释备用文案
    brandSlogan: "AI 原生物流操作系统",
    brandDesc: "让 AI 协助处理您的物流运营。",
    assistant247: "全天候 AI 运营助手",
    poweredByEva: "由 EVA 提供支持",
    consentPrefix: "我已阅读并同意",
    terms: "《服务条款》",
    consentMiddle: "，并确认已知悉",
    privacy: "《隐私政策》",
    consentSuffix: "。",
    consentText: "我已阅读并同意《服务条款》，并确认已知悉《隐私政策》。",
    consentRequired: "请先阅读并同意服务条款和隐私政策",
    legalCopyright: "© 2026 ZD WORLD INC. ECPAI 是由 ZD WORLD INC. 拥有并运营的品牌。",
    prohibited: "禁运品政策",
    requiredMessage: {
      account: "请输入账号",
      code: "请输入验证码",
      phone: "请输入手机号",
      newPassword: "请输入新密码",
      reEnterPassword: "请再次输入密码",
      passwordNotMatch: "两次输入密码不一致!",
    },
    formatMessage: {
      phone: "手机号格式不正确", // 注释备用文案
      email: "邮箱格式不正确",
    },
  },
  user: {
    password: {
      oldPassword: "旧密码",
      newPassword: "新密码",
      confirmPassword: "确认密码",
      placeholder: {
        inputOldPassword: "请输入旧密码",
        inputNewPassword: "请输入新密码",
        inputConfirmPassword: "请输入确认密码",
      },
      submit: "提交",
      reset: "重置",
      requiredMessage: {
        oldPassword: "请输入旧密码",
        newPassword: "请输入新密码",
        reEnterPassword: "请再次输入密码",
        passwordNotMatch: "两次输入密码不一致!",
      },
    },
    member: {
      memberName: "会员姓名",
      personalProfile: "个人简介",
      remainingAmount: "剩余金额",
      totalPoints: "所有积分",
      loginTime: "登录时间",
      lastLogin: "最后登录",
    },
    info: {
      personalInfo: "个人信息",
      loginUser: "登录用户：",
      balance: "余额：", // 注释备用文案
      basicInfo: "基本信息",
      username: "用户名",
      nickname: "昵称",
      email: "邮箱",
      contactInfo: "联系方式",
      placeholder: {
        inputNickname: "请输入昵称",
        inputEmail: "请输入邮箱",
        inputContact: "请输入联系方式",
      },
      confirm: "确认",
      editEmail: "修改邮箱",
      editPhone: "修改手机号",
    },
    agreement: {
      content1:
        "欢迎使用Adapay平台协议支付服务，本服务由上海汇付数据服务有限公司（本公司）向您提供。在接受本服务协议之前，请您充分、阅读理解本协议的全部内容。您通过平台页面完成点击确认操作即表示双方已达成本协议。您承诺具有法律规定的完全民事权利能力和行为能力，且为能够独立承担民事责任，您已充分阅读并理解接受本协议的全部约定内容，若您不符合上述要求或不同意本协议内容，或者无法准确理解相关条款含义，应当立即停止后续操作，并与本公司及时取得联系，对于已经实际开展的双方合作，本公司将予以暂停，已经签署的相关产品合作协议视为中止。本协议的签署时间以本公司系统显示为准。",
      content2:
        "您同意，本公司有权对本协议内容进行修改，并在本界面以公告的方式公布，无需另行通知;若您在本公司公告协议内容变更后继续与本公司展开合作的，表示您已充分阅读、理解并接受修改后的协议内容；若您不同意修改后的协议内容，或者无法准确理解相关条款含义，应当立即停止后续操作，并与本公司及时取得联系，对于已经实际开展的双方合作，本公司将予以暂停，已经签署的相关产品合作协议视为中止。",
      content3:
        "本公司已采取合理方式提请您注意本协议的全部条款，并对其内容进行了充分说明。您自愿按照本协议的约定行使权利和履行义务。",
      title1: "一、权利义务",
      item1_1:
        "1.您保证您是使用本服务的银行卡持有人，可合法、有效使用该银行卡且未侵犯任何第三方合法权益，否则，因此造成本公司、持卡人损失的，您应负责赔偿并承担法律责任。",
      item1_2:
        "2.您应确保开通本服务所提供的手机号码为您本人所有，为此，您理解并同意本公司通过第三方渠道对您所提供手机号码的真实性、有效性进行核实。",
      item1_3:
        "3.为了防范交易风险及保障您的资金安全，您理解并同意本公司使用您提供的信息，如：姓名、身份证件号码、手机号码、银行卡信息（卡号、有效期、卡验证码等）及预留手机号，与发卡行进行交叉验证。",
      item1_4:
        "4.出于提供本服务的目的，您授权本公司收集您的姓名、身份证件号码、手机号码、银行卡信息（卡号、有效期、卡验证码等）等个人信息；本公司重视对个人信息处理与保护，将遵循合法、正当、必要的原则收集您的个人信息并严格保护您个人信息。",
      item1_5:
        "5.您应妥善保管银行卡、卡号、密码、发卡行预留的手机号码、数字证书、手机动态口令、校验码等与银行卡有关的信息和设备。如您遗失或泄露前述信息和/或设备的，您应及时通知发卡行及/或本公司。无论您是否已通知发卡行及/或本公司，因您自身原因所致损失由您自行承担。",
      item1_6:
        "6.您在使用本服务时，应当认真确认交易信息，包括且不限于商品名称、数量、金额等。您知悉并同意：您发出的指令不可撤销，本公司根据您的指令从银行卡中划扣资金给收款人，您不应以非本人意愿交易或其他原因要求本公司承担任何责任。",
      item1_7:
        "7.您在对使用本服务过程中发出指令的真实性及有效性负责，本公司依照您的指令进行操作的风险须由您承担。交易数据以本公司记载为准。",
      item1_8:
        "8.您承诺您使用本服务时所提供的个人信息真实、合法、有效、完整、准确。本公司将按照您设置的相关信息为您提供相应服务。若您设置的信息有误，您需自行承担相应责任及风险。",
      item1_9:
        "9.您同意本公司为满足反洗钱及监管的要求，留存您的交易记录。在您使用本服务期间及本服务终止后，您理解并同意本公司在相关法律法规或监管要求的期限内保留您在使用本服务过程中提供或新产生的相关信息。",
      item1_10:
        "10.出现下列情況之一的，本公司有权立即终止您使用本服务而免于承担任何责任： （1）将本服务用于非法目的； （2） 违反本协议的约定; （3） 本公司认为向您提供本服务存在交易风险的；（4）您的银行卡 无效、有效期届满或注销。",
      title2: "二、适用法律及争议解决",
      item2_1:
        "1.本协议的解释、适用、争议解决等一切事宜，均适用中华人民共和国法律(香港特别行政区、澳门特别行政区和台湾地区的法律除外），冲突法规则除外。",
      item2_2:
        "2.因本协议产生任何纠纷时，各方应友好协商，协商不成的，各方应将争议提交本公司住所地有管辖权的人民法院诉讼解决，且诉讼费用（包括律师费、公证费等）由败诉方承担。",
    },
    phone: {
      newPhoneNumber: "新手机号",
      verificationCode: "验证码",
      placeholder: {
        inputPhone: "请输入手机号",
        inputCode: "请输入验证码",
      },
      getCode: "获取验证码",
      getCodeCountdown: "获取验证码({0})",
      submit: "提交",
      reset: "重置",
      requiredMessage: {
        phone: "请输入手机号",
        smsCode: "请输入验证码",
      },
      formatMessage: {
        phone: "手机号格式不正确",
        smsCode: "验证码格式不正确",
      },
    },
    email: {
      newEmail: "新邮箱",
      verificationCode: "验证码",
      placeholder: {
        inputEmail: "请输入新邮箱",
        inputCode: "请输入验证码",
      },
      getCode: "获取验证码",
      getCodeCountdown: "获取验证码({0})",
      submit: "提交",
      reset: "重置",
      requiredMessage: {
        email: "请输入邮箱",
        smsCode: "请输入验证码",
      },
      formatMessage: {
        email: "邮箱格式不正确",
        smsCode: "验证码格式不正确",
      },
    },
  },
  order: {
    place: {
      title: {
        shipperInfo: "发货信息",
        consigneeInfo: "收货信息",
        cargoGoods: "货运/商品",
        scheduledPickup: "预约取件",
        packagingInfo: "封装信息",
        packageInfo: "包裹信息",
        selectSenderAddress: "选择发件地址",
        selectFbaAddress: "选择FBA地址",
        selectReceiverAddress: "选择收件地址",
      },
      label: {
        name: "姓名",
        company: "公司",
        country: "国家/地区",
        stateProvince: "州/省",
        city: "城市",
        zipCode: "邮编",
        address1: "地址1",
        address2: "地址2",
        address3: "地址3",
        phone: "电话",
        email: "邮箱",
        logisticsChannel: "物流渠道",
        ecommerceOrderNo: "电商订单号",
        labelRemark: "面单备注",
        remarks: "备注留言",
        shipDate: "发货日期",
        signatureRequired: "是否签名",
        packageType: "包裹类型",
        sku: "Sku",
        packageQuantity: "包裹数量",
        dimensions: "长*宽*高",
        weight: "重量",
        declaredValue: "申报价值",
        totalPackages: "包裹总数",
        totalWeight: "总重量",
        pickupDate: "取货日期",
        readyTime: "准备时间",
        latestTime: "最晚时间",
        specialInstructions: "特殊说明",
      },
      placeholder: {
        enterName: "请输入姓名",
        enterCompany: "请输入公司",
        selectCountry: "请选择省国家",
        selectState: "请选择省州/省",
        enterCity: "请输入城市",
        enterZipCode: "请输入邮编",
        enterAddress1: "请输入地址1",
        enterAddress2: "请输入地址2",
        enterAddress3: "请输入地址3",
        enterPhone: "请输入电话",
        enterEmail: "请输入邮箱",
        selectLogisticsChannel: "请选择物流渠道",
        enterEcommerceOrderNo: "请输入电商订单号",
        enterLabelRemark: "请输入面单备注",
        enterRemarks: "请输入备注留言",
        selectShipDate: "请选择发货日期",
        selectSignature: "请选择是否签名",
        selectPackageType: "请选择包裹类型",
        enterSku: "请输入Sku",
        enterPackageQuantity: "请输入数量",
        enterDimensions: "请输入长宽高",
        enterWeight: "请输入重量",
        enterTotalPackages: "请输入包裹总数",
        enterTotalWeight: "请输入总重量",
        selectPickupDate: "请输入取货日期",
        selectReadyTime: "请选择准备时间",
        selectLatestTime: "请选择最晚可用时间",
        enterSpecialInstructions: "请输入特殊说明",
      },
      button: {
        clear: "清除",
        saveToAddressBook: "保存到地址簿",
        verifyAddress: "校验地址",
        swapAddress: "交换地址",
        predictRate: "确认",
        saveDraft: "保存草稿",
        generateOrder: "生成物流运单",
        storeShipment: "门店发货",
        reset: "重置",
        copyPackage: "复制包裹",
      },
      options: {
        signature: {
          noSignature: "不签名",
          adultSignature: "成人签名传",
          standardSignature: "普通签名传",
        },
      },
      unit: {
        lbIn: "磅/英寸",
        kgCm: "千克/厘米",
        in: "in",
        cm: "cm",
        lb: "lb",
        kg: "KG",
        currency: "$",
      },
      pa_unit: '磅/英寸',
      tips: {
        weightDimensions: "提示：包裹重量和尺寸会直接影响运输费用",
      },
      validation: {
        enterShipperName: "请输入发件人姓名",
        selectShipperCountry: "请选择发件人国家",
        selectShipperState: "请选择发件人州/省",
        enterShipperCity: "请输入发件人城市",
        enterShipperZip: "请输入发件人邮编",
        enterShipperAddress: "请输入发件人地址1",
        enterShipperPhone: "请输入发件人电话",
        enterConsigneeName: "请输入收件人姓名",
        selectConsigneeCountry: "请选择收件人国家",
        selectConsigneeState: "请选择收件人州/省",
        enterConsigneeCity: "请输入收件人城市",
        enterConsigneeZip: "请输入收件人邮编",
        enterConsigneeAddress: "请输入收件人地址1",
        enterConsigneePhone: "请输入收件人电话",
        selectLogisticsChannel: "请选择物流渠道",
        enterPickupName: "请输入预约人姓名",
        selectPickupCountry: "请选择预约国家",
        selectPickupState: "请选择预约州/省",
        enterPickupCity: "请输入预约城市",
        enterPickupZip: "请输入预约邮编",
        enterPickupAddress: "请输入预约地址1",
        enterPickupPhone: "请输入预约电话",
        selectPackageType: "请选择包裹类型",
        enterTotalPackages: "请输入包裹总数",
        enterTotalWeight: "请输入总重量",
        selectPickupDate: "请选择取货日期",
        selectReadyTime: "请输入准备时间",
        selectLatestTime: "请输入最晚可用时间",
        enterSku: "请输入Sku",
        enterPackageQuantity: "请输入数量",
        enterWeight: "请输入重量",
        enterDimensions: "请输入长宽高",
      },
      dialog: {
        predictCost: "预测费用",
        verifyResult: "校验结果",
      },
      message: {
        predictFailed: "预测费率失败！",
        createOrderFailed: "生成订单失败！",
        saveDraftFailed: "保存草稿失败！",
      },
      ratePrediction: {
        costPrediction: "费用率预测：",
      },
    },
    list: {
      tabAll: "全部",
      tabWaitPrint: "待打单",
      tabWaitShip: "待发货",
      tabShipped: "已发货",
      tabCancelled: "已取消",
      tabRefunded: "已退款",
    },
    check: {
      checkTip: "经过校验，类型：",
      businessAddr: "商业地址",
      residentialAddr: "住宅地址",
      confirmBtn: "确定",
    },
    errmsg: {
      confirmBtn: "确定",
    },
    free: {
      select: "选择",
      serialNo: "序号",
      logisticsProduct: "物流产品",
      totalFreight: "总运费",
      fuelSurcharge: "燃油",
      insuranceFee: "保费",
      weight: "重量",
      deliveryDays: "预计到达",
      residentialFee: "住宅",
      ahsFee: "AHS",
      osFee: "OS",
      pickupFee: "预约取件费用",
      otherFee: "其他",
      serviceNotSupport: "该渠道服务不支持",
      failReason: "失败原因",
      failReasonTip: "该渠道报价为0，鼠标悬停查看失败原因",
      bestPrice: "价格最优：",
      rmbExchange: "兑换成人民币：",
      confirmBtn: "确定",
    },
    rateProgress: {
      title: "正在测算运费",
      subtitle: "系统正在向所有可用渠道查询费率，请稍候...",
      completed: "已完成 {done}/{total} 个渠道",
      statusPending: "等待中",
      statusLoading: "测算中",
      statusDone: "完成",
      statusFail: "失败",
    },
    importEx: {
      file: "文件",
      selectFile: "选择文件",
      templateDownload: "模板下载",
      template: "导入模板",
      fedexTemplate: "FedEx导入模板",
      upsTemplate: "UPS导入模板",
      importTip: "导入提示",
      pleaseSelectProvider: "请选择服务商",
      provider: "服务商",
    },
    morePds: {
      pdfLink: "PDF链接：",
      confirmBtn: "确定",
    },
    orderList: {
      countryStateProvince: "国家/州/省",
      receiveAddress: "收件地址",
      receiveAddressName: '收件人姓名',
      receiveAddressNameY: '请输入收件人姓名',
      receivePhone: "收件电话",
      ecommerceOrderNo: "电商订单号",
      logisticsOrderNo: "物流单号/订单编号",
      createTime: "创建时间",
      startDate: "开始日期",
      endDate: "结束日期",
      query: "查询",
      reset: "重置",
      batchCreateWaybill: "批量生成打单",
      batchEstimateFreight: "批量预估运费",
      batchDelete: "批量删除",
      batchCancelOrder: "批量取消订单",
      exportData: "导出数据",
      batchPrint: "批量打印",
      importOrder: "导入订单",
      batchVerifyAddress: "批量校验地址",
      serialNo: "序号",
      orderNo: "订单编号",
      addressType: "地址类型",
      residential: "住宅",
      business: "商业",
      logisticsInfo: "物流信息",
      logisticsNo: "物流单号",
      logisticsProvider: "物流服务商",
      packageCount: "件数",
      weight: "重量",
      cost: "费用",
      deductionAmount: "扣款金额",
      fuelFee: "燃油费",
      remoteFee: "偏远费",
      residentialFee: "住宅费",
      insuranceAmount: "保险金额",
      recipient: "收件人",
      country: "国家/地区",
      stateProvince: "州/省",
      address: "地址",
      name: "姓名",
      phone: "电话",
      postalCode: "邮编",
      createDate: "创建日期",
      verificationStatus: "验证状态",
      isMultiPackage: "是否多包裹",
      isSignature: "是否签名",
      yes: "是",
      no: "否",
      isInternational: "是否国际单",
      isScheduledPickup: "是否预约取件",
      pickupFailed: "预约取件失败",
      pickupConfirmationCode: "预约取件码",
      operation: "操作",
      copyAsNewOrder: "复制为新订单",
      pdfFile: "PDF文件",
      viewInvoice: "查看发票",
      barcode: "条形码",
      packageInfo: "包裹信息",
      getWaybill: "获取面单",
      viewStoreShippingOrder: "查看门店发货单",
      confirmPrintSelected: "确认打印选中订单?",
      confirmDeleteSelected: "确认删除选中订单?",
      confirmVerifySelectedAddress: "确认校验选中订单地址?",
      confirmCancelSelected: "确认取消选中订单?",
      confirmCreateWaybill: "确认将选中打单?",
      confirmEstimateFreight: "确认预估选中订单运费?",
      warmTip: "温馨提示",
      copySuccess: "复制成功",
      getWaybillFail: "获取面单失败！",
      loadingLabelInvoice: "正在生成面单和发票，请稍候...",
      batchPrintTitle: "批量打印",
      viewStoreShippingOrderTitle: "查看门店发货单",
      viewPdfFileTitle: "查看PDF文件",
      viewBarcodeTitle: "查看条形码",
      viewPackageInfoTitle: "查看包裹信息",
      waybillTitle: "打单",
      estimateFreightTitle: "预估运费",
      editTitle: "编辑",
      importOrderTitle: "导入订单",
      verificationResultTitle: "校验结果",
      orderInvoiceTitle: "订单发票",
      batchSearchPlaceholder: "批量搜索物流单号/订单编号",
      enterReceiveAddress: "请输入收件地址",
      enterReceivePhone: "请输入收件电话",
      enterEcommerceOrderNo: "请输入电商订单号",
    },
    pickup: {
      btn: "预约取件",
      title: "预约取件",
      tipFee: "本次预约将扣除 $24，重复预约重复扣费",
      tipTimeWindow: "取件时间窗：截止时间需晚于准备时间至少 2 小时，且不早于 12:00 pm，否则承运商会拒绝预约",
      reuseSender: "复用发件人信息",
      sourceInfo: "取货源件",
      packageInfo: "包裹信息",
      labelName: "姓名",
      labelCompany: "公司",
      labelCountry: "国家/地区",
      labelProvince: "州/省",
      labelCity: "城市",
      labelZcode: "邮编",
      labelAddress1: "地址1",
      labelAddress2: "地址2",
      labelMobile: "电话",
      labelTotalPackages: "包裹总数",
      labelTotalWeight: "总重量(磅)",
      labelPickupDate: "取货日期",
      labelReadyTime: "准备时间",
      labelLatestTime: "截止时间",
      labelRemark: "特殊说明",
      placeholderName: "请输入姓名",
      placeholderCompany: "请输入公司",
      placeholderCountry: "请选择国家",
      placeholderProvince: "请选择州/省",
      placeholderCity: "请输入城市",
      placeholderZcode: "请输入邮编",
      placeholderAddress1: "请输入地址1",
      placeholderAddress2: "请输入地址2",
      placeholderMobile: "请输入电话",
      placeholderTotalPackages: "请输入包裹总数",
      placeholderTotalWeight: "请输入总重量",
      placeholderPickupDate: "请选择取货日期",
      placeholderReadyTime: "请选择准备时间",
      placeholderLatestTime: "请选择截止时间",
      placeholderRemark: "请输入特殊说明",
      submit: "确认并扣费",
      cancel: "取消",
      confirmTitle: "温馨提示",
      confirmContent: "本次预约将扣除 $24，重复预约重复扣费，是否继续？",
      success: "预约取件成功",
      statusBooked: "已预约",
      statusFailed: "预约失败",
      statusNone: "未预约",
      historyTitle: "预约历史",
      colDate: "提交时间",
      colPRN: "确认号",
      colStatus: "状态",
      colMoney: "费用",
      colMsg: "备注",
      errWindowTooShort: "截止时间必须比准备时间晚至少 2 小时",
      errCloseTooEarly: "截止时间不能早于 12:00 pm",
      errTodayTooLate: "取件日期为今天时，准备时间必须在当前时间 2 小时之后，建议选择明天",
    },
    parcel: {
      serialNo: "序号",
      logisticsNo: "物流单号",
      size: "尺寸",
      weight: "重量",
      inch: "英寸",
      centimeter: "厘米",
      pound: "磅",
      kilogram: "千克",
      totalWeight: "总重量",
      totalVolumeWeight: "总体积重量",
    },
    fplace: {
      title: {
        shipperInfo: "发货信息",
        consigneeInfo: "收货信息",
        cargoGoods: "货运/商品",
        scheduledPickup: "预约取件",
        packagingInfo: "封装信息",
        packageInfo: "包裹信息",
        declaredItems: "申报项目",
      },
      label: {
        name: "姓名",
        company: "公司",
        country: "国家/地区",
        stateProvince: "州/省",
        city: "城市",
        zipCode: "邮编",
        address1: "地址1",
        address2: "地址2",
        address3: "地址3",
        phone: "电话",
        email: "邮箱",
        logisticsChannel: "物流渠道",
        ecommerceOrderNo: "电商订单号",
        labelRemark: "面单备注",
        remarks: "备注留言",
        shipDate: "发货日期",
        signatureRequired: "是否签名",
        bookingConfirmationNumber: "货运订舱号",
        packageType: "包裹类型",
        sku: "Sku",
        packageQuantity: "包裹数量",
        dimensions: "长*宽*高",
        weight: "重量",
        declaredValue: "申报价值",
        itemQtyValue: '物品件数',
        customsCode: "海关编码",
        unitOfMeasure: "计量单位",
        productValue: "商品价值",
        productDescription: "产品描述",
        quantity: "数量",
        netWeight: "净重",
        origin: "产地",
        packageContent: "包装内容",
        packageContentOption: "包装内容选项",
        totalPackages: "包裹总数",
        totalWeight: "总重量",
        pickupDate: "取货日期",
        readyTime: "准备时间",
        latestTime: "最晚时间",
        specialInstructions: "特殊说明",
      },
      placeholder: {
        enterName: "请输入姓名",
        enterCompany: "请输入公司",
        selectCountry: "请选择国家",
        selectState: "请选择州/省",
        enterCity: "请输入城市",
        enterZipCode: "请输入邮编",
        enterAddress1: "请输入地址1",
        enterAddress2: "请输入地址2",
        enterAddress3: "请输入地址3",
        enterPhone: "请输入电话",
        enterEmail: "请输入邮箱",
        selectLogisticsChannel: "请选择物流渠道",
        enterEcommerceOrderNo: "请输入电商订单号",
        enterLabelRemark: "请输入面单备注",
        enterRemarks: "请输入备注留言",
        selectShipDate: "请选择发货日期",
        selectSignature: "请选择是否签名",
        enterBookingConfirmationNumber: "FedEx货运服务需先电话订舱，请填入订舱号（选填）",
        selectPackageType: "请选择包裹类型",
        enterSku: "请输入Sku",
        enterQuantity: "请输入数量",
        enterDimensions: "请输入长宽高",
        enterWeight: "请输入重量",
        enterCustomsCode: "请输入海关编码",
        selectUnit: "请选择",
        enterProductValue: "请输入商品价值",
        enterProductDescription: "请输入产品描述",
        enterNetWeight: "请输入净重",
        selectOrigin: "请选择",
        selectPackageContent: "请选择包装内容",
        selectContentOption: "请选择",
        enterTotalPackages: "请输入包裹总数",
        enterTotalWeight: "请输入总重量",
        selectPickupDate: "请输入取货日期",
        selectReadyTime: "请选择准备时间",
        selectLatestTime: "请选择最晚可用时间",
        enterSpecialInstructions: "请输入特殊说明",
        selectSenderAddress: "选择发件地址",
        selectFbaAddress: "选择FBA地址",
        selectReceiverAddress: "选择收件地址",
      },
      button: {
        clear: "清除",
        saveToAddressBook: "保存到地址簿",
        verifyAddress: "校验地址",
        swapAddress: "交换地址",
        predictRate: "确认",
        saveDraft: "保存草稿",
        generateOrder: "生成物流运单",
        storeShipment: "门店发货",
        reset: "重置",
        copyPackage: "复制包裹",
      },
      options: {
        signature: {
          noSignature: "不签名",
          adultSignature: "成人签名传",
          standardSignature: "普通签名传",
        },
        packageContent: {
          item: "项目",
          document: "文件",
        },
        itemTypes: {
          commercial: "Commercial",
          gift: "Gift",
          sample: "Sample",
          repairReturn: "Repair and return",
          personalEffects: "Personal effects",
          personalUse: "Personal use",
        },
        documentTypes: {
          personal: "Personal document (e.g.letter)",
          interoffice: "Interoffice document (e.g.memo)",
          business: "Business document (e.g. contract)",
          other: "Other",
        },
      },
      unit: {
        lbIn: "磅/英寸",
        kgCm: "千克/厘米",
        in: "in",
        cm: "cm",
        lb: "lb",
        kg: "KG",
        currency: "$",
      },
      pa_unit: '磅/英寸',
      tips: {
        weightDimensions: "提示：包裹重量和尺寸会直接影响运输费用",
      },
      validation: {
        enterShipperName: "请输入发件人姓名",
        selectShipperCountry: "请选择发件人国家",
        selectShipperState: "请选择发件人州/省",
        enterShipperCity: "请输入发件人城市",
        enterShipperZip: "请输入发件人邮编",
        enterShipperAddress: "请输入发件人地址1",
        enterShipperPhone: "请输入发件人电话",
        enterConsigneeName: "请输入收件人姓名",
        selectConsigneeCountry: "请选择收件人国家",
        selectConsigneeState: "请选择收件人州/省",
        enterConsigneeCity: "请输入收件人城市",
        enterConsigneeZip: "请输入收件人邮编",
        enterConsigneeAddress: "请输入收件人地址1",
        enterConsigneePhone: "请输入收件人电话",
        selectLogisticsChannel: "请选择物流渠道",
        enterPickupName: "请输入预约人姓名",
        selectPickupCountry: "请选择预约国家",
        selectPickupState: "请选择预约州/省",
        enterPickupCity: "请输入预约城市",
        enterPickupZip: "请输入预约邮编",
        enterPickupAddress: "请输入预约地址1",
        enterPickupPhone: "请输入预约电话",
        selectPackageType: "请选择包裹类型",
        enterTotalPackages: "请输入包裹总数",
        enterTotalWeight: "请输入总重量",
        selectPickupDate: "请选择取货日期",
        selectReadyTime: "请输入准备时间",
        selectLatestTime: "请输入最晚可用时间",
        enterCustomsCode: "请输入海关编码",
        customsCodeFormat: "海关编码请输入 6-10 位数字（HS Code，例如：610910）",
        enterUnit: "请输入计量单位",
        enterProductValue: "请输入商品价值",
        enterProductDescription: "请输入产品描述",
        enterPackageKind: "请输入包装种类",
        enterQuantity: "请输入数量",
        enterNetWeight: "请输入净重",
        enterOrigin: "请输入产地",
        selectPackageContent: "请选择包装内容",
        selectContentOption: "请选择包装内容选项",
        enterSku: "请输入Sku",
        enterPackageQuantity: "请输入数量",
        enterWeight: "请输入重量",
        enterDimensions: "请输入长宽高",
      },
      dialog: {
        predictCost: "预测费用",
        verifyResult: "校验结果",
      },
      message: {
        predictFailed: "预测费率失败！",
        createOrderFailed: "生成订单失败！",
        saveDraftFailed: "保存草稿失败！",
      },
      resolution: {
        jiexidizhi: '解析地址',
        guanbi: '关闭',
        tijiao: '提交',
        dizhi:'必须按以下格式填写：\n1. 第一行：姓名\n2. 第二行：电话\n3. 第三行：地址,城市,州 邮编',
        dizhibk:'地址不能为空',
        dizhigeshi: '地址格式错误！必须按以下格式填写：\n1. 第一行：姓名\n2. 第二行：电话\n3. 第三行：地址,城市,州 邮编',
        xingming:'姓名不能为空！',
        dianhua: '电话不能为空！',
        dizhihang: '地址行格式错误！必须为：地址,城市,州 邮编',
        dizhikhang:'地址、城市、州 邮编均不能为空！',
        meiguozhou: '请填写有效的美国州名称'
      }
    },
  },
  components: {
    calc: {
      zipCode: "邮编",
      isResidential: "是否住宅地址",
      unit: "单位",
      lbInch: "磅/英寸",
      kgCm: "千克/厘米",
      weight: "重量",
      oz: "盎司",
      length: "长",
      width: "宽",
      height: "高",
      parcelNum: "包裹数量",
      searchType: "查询类型",
      all: "全部",
      getRates: "获取费率",
      reset: "重置",
      service: "服务类型",
      packageType: "包裹类型",
      rate: "费率",
      action: "操作",
      shipFrom: "路由信息",
      packageInfo: "包裹信息",
      from: "发件国家",
      to: "收件国家",
      useThis: "下单",
      emptyText: "请输入信息后点击「获取费率」",
      pleaseSelectShipCountry: "请选择发货国家",
      pleaseEnterShipZipCode: "请输入发货邮编",
      pleaseSelectReceiveCountry: "请选择收货国家",
      pleaseEnterReceiveZipCode: "请输入收货邮编",
      pleaseEnterWeight: "请输入重量",
      pleaseEnterLength: "请输入长",
      pleaseEnterWidth: "请输入宽",
      pleaseEnterHeight: "请输入高",
    },
    message: {
      latestNotice: "最新通知公告",
      noticeDetail: "通知详情",
      viewDetail: "查看详情",
      close: "关闭",
    },
    tip: {
      followWechat: "关注微信",
      backToTop: "回到顶部",
    },
  },
  ltluser: {
    personalInfo: "个人信息",
    firstName: "名",
    lastName: "姓",
    phone: "手机号",
    phoneExt: "电话分机",
    companyInfo: "公司信息",
    companyName: "公司名称",
    companyAddress: "公司地址",
    businessLicense: "营业执照",
    password: "密码",
    currentPwd: "当前密码",
    newPwd: "新密码",
    confirmPwd: "确认密码",
    confirm: "确认",
    pleaseEnterFirstName: "请输入名",
    pleaseEnterLastName: "请输入姓",
    pleaseEnterPhone: "请输入手机号",
    pleaseEnterPhoneExt: "请输入电话分机",
    pleaseEnterCompanyName: "请输入公司名称",
    pleaseEnterCompanyAddress: "请输入公司地址",
    pleaseEnterCurrentPwd: "请输入当前密码",
    pleaseEnterNewPwd: "请输入新密码",
    pleaseEnterConfirmPwd: "请输入确认密码",
    uploadSizeLimit: "上传图片大小不能超过 10MB!",
  },
  ltlindex: {
    ltlOrderMgmt: "LTL订单管理",
    ltlRateMgmt: "LTL报价管理",
    ltlAddressMgmt: "LTL地址管理",
    expressOrderMgmt: "快递订单管理",
    expressAddressMgmt: "快递地址管理",
    personalCenter: "个人中心",
  },
  ltlwork: {
    list: {
      myWorkOrder: "我的工单",
      workOrderNo: "工单号",
      workOrderStatus: "工单状态",
      inProgress: "进行中",
      resolved: "已解决",
      closed: "已闭合",
      replied: "已回复",
      search: "查询",
      reset: "重置",
      addWorkOrder: "新增工单",
      serialNo: "序号",
      workOrderTitle: "工单标题",
      description: "描述信息",
      createTime: "创建时间",
      operation: "操作",
      view: "查看",
      addWorkOrderDialog: "新增工单",
      workOrderDetail: "工单详情",
      pleaseEnterWorkOrderNo: "请输入工单号",
      pleaseSelectWorkOrderStatus: "请选择工单状态",
    },
    form: {
      workOrderTitle: "工单标题",
      orderNo: "订单号",
      description: "描述信息",
      uploadFile: "上传文件",
      submit: "提交",
      reset: "重置",
      pleaseEnterWorkOrderTitle: "请输入工单标题",
      pleaseEnterOrderNo: "请输入订单号",
      pleaseEnterDescription: "请输入描述信息",
      uploadSizeLimit: "上传文件大小不能超过 10MB!",
    },
    workView: {
      workOrderInfo: "工单信息",
      workOrderTitle: "工单标题",
      workOrderNo: "工单号",
      workOrderStatus: "工单状态",
      submitTime: "提交时间",
      orderNo: "订单号",
      description: "描述信息",
      attachment: "附件",
      feedbackRecords: "反馈记录",
      noRecords: "暂无记录哦~",
      replyInfo: "回复信息",
      pleaseEnterDescription: "请输入描述信息",
      uploadFile: "上传文件",
      reply: "回复",
      attachmentDownload: "附件下载",
      inProgress: "进行中",
      resolved: "已解决",
      closed: "已闭合",
      replied: "已回复",
      uploadSizeLimit: "上传文件大小不能超过 10MB!",
    },
  },
  product: {
    list: {
      projectName: "项目名称",
      lengthWidthHeight: "长*宽*高",
      weight: "重量",
      freightClass: "货运等级",
      palletType: "打托类型",
      productUnit: "商品单位",
      cargoCategoryCode: "货物类别编码",
      subcategoryCode: "子类别编码",
      operation: "操作",
      edit: "修改",
      delete: "删除",
      select: "选择",
      serialNo: "序号",
      search: "查询",
      reset: "重置",
      addProduct: "新增产品",
      addProductDialog: "新增产品",
      editProductDialog: "编辑产品",
      pleaseEnterProjectName: "请输入项目名称",
      confirmDelete: "确认删除?",
      warmTip: "温馨提示",
      yes: "是",
      no: "否",
    },
    form: {
      projectName: "项目名称",
      freightClass: "货运等级",
      length: "长",
      width: "宽",
      height: "高",
      weight: "重量",
      palletType: "打托类型",
      productUnit: "商品单位",
      cargoCategoryCode: "货物类别编码",
      subcategoryCode: "子类别编码",
      submit: "提交",
      reset: "重置",
      pleaseEnterProjectName: "请输入项目名称",
      pleaseSelectFreightClass: "请选择货运等级",
      pleaseEnterLength: "请输入长",
      pleaseEnterWidth: "请输入宽",
      pleaseEnterHeight: "请输入高",
      pleaseEnterWeight: "请输入重量",
      pleaseSelectPalletType: "请选择打托类型",
      pleaseSelectProductUnit: "请选择商品单位",
      pleaseEnterCargoCategoryCode: "请输入货物类别编码",
      pleaseEnterSubcategoryCode: "请输入子类别编码",
      setAsDefaultAddress: "设置成默认地址",
    },
  },
  price: {
    FBA: {
      fbaQuote: "FBA报价",
      origin: "起始地",
      warehouseCode: "仓库代码",
      numberOfPallets: "托盘数",
      calculateFreight: "计算运费",
      pleaseEnterWarehouseCode: "请输入仓库代码",
      pleaseEnterPalletCount: "请输入托盘数",
      amazonLtlFreight: "亚马逊卡派运费",
      truckingFee: "卡车运费",
      quoteExpirationTime: "报价截止时间",
      palletSizeRequirement: "托盘尺寸要求",
      serialNo: "序号",
      ftlRate28Pallets: "FTL Rate(28 Pallets)",
      warehouseEntryTime: "进仓时间",
      to: "收件方:",
      noData: "暂无数据",
      calculationSuccess: "计算成功",
      calculationFailed: "计算失败",
    },
    rateList: {
      quoteList: "报价列表",
      shippingAddress: "发货地址",
      receivingAddress: "收货地址",
      search: "查询",
      reset: "重置",
      onlineQuote: "在线报价",
      serialNo: "序号",
      quoteNo: "报价号",
      quoteDate: "报价日期",
      operation: "操作",
      edit: "编辑",
      delete: "删除",
      pickupDate: "取货日期",
      deliveryDate: "交货日期",
      quotePrice: "报价价格",
      confirmDelete: "确认删除?",
      warmTip: "温馨提示",
      pleaseEnterShippingAddress: "请输入发货地址",
      pleaseEnterReceivingAddress: "请输入收货地址",
    },
  },
  ltladdress: {
    list: {
      contactPerson: "联系人",
      addressType: "地址类型",
      contactPhone: "联系电话",
      search: "查询",
      reset: "重置",
      addAddress: "新增地址",
      serialNo: "序号",
      addressName: "地址名称",
      address: "地址",
      shippingReceivingPlace: "收发货地",
      contactEmail: "联系邮箱",
      isDefault: "是否默认",
      operation: "操作",
      modify: "修改",
      delete: "删除",
      select: "选择",
      pleaseEnterContactPerson: "请输入联系人",
      pleaseSelectAddressType: "请选择地址类型",
      pleaseEnterContactPhone: "请输入联系电话",
      shippingAddress: "发货地址",
      receivingAddress: "收货地址",
      yes: "是",
      no: "否",
      confirmDelete: "确认删除?",
      warmTip: "温馨提示",
      addAddressTitle: "新增地址",
      editAddressTitle: "编辑地址",
      deleteSuccess: "删除成功",
      deleteFailed: "删除失败",
    },
    form: {
      shippingReceivingPlace: "收发货地",
      addressType: "地址类型",
      contactPerson: "联系人",
      contactEmail: "联系邮箱",
      contactPhone: "联系电话",
      addressName: "地址名称",
      address1: "地址1",
      address2: "地址2",
      address3: "地址3",
      zipCode: "邮编",
      city: "城市",
      stateProvince: "州/省",
      country: "国家/地区",
      setAsDefaultAddress: "设置成默认地址",
      submit: "提交",
      reset: "重置",
      pleaseSelectShippingReceivingPlace: "请选择收发货地",
      originLocation: "发货地",
      destinationLocation: "收货地",
      pleaseSelectAddressType: "请选择地址类型",
      shippingAddress: "发货地",
      receivingAddress: "收货地",
      pleaseEnterContactPerson: "请输入联系人",
      pleaseEnterContactEmail: "请输入联系邮箱",
      pleaseSelectPhoneCode: "请选择电话区号",
      pleaseEnterContactPhone: "请输入联系电话",
      pleaseEnterAddressName: "请输入地址名称",
      pleaseEnterAddress1: "请输入地址1",
      pleaseEnterAddress2: "请输入地址2",
      pleaseEnterZipCode: "请输入邮编",
      pleaseEnterCity: "请输入城市",
      pleaseSelectStateProvince: "请选择州/省",
      pleaseSelectCountry: "请选择国家",
      submitSuccess: "提交成功",
      submitFailed: "提交失败",
      updateSuccess: "修改成功",
      updateFailed: "修改失败",
    },
  },
  ltlfinance: {
    finance: {
      announcementList: "公告列表",
      time: "时间",
      startDate: "开始日期",
      endDate: "结束日期",
      to: "至",
      query: "查询",
      reset: "重置",
      serialNumber: "序号",
      orderNumber: "订单号",
      consumptionType: "消费类型",
      paymentMethod: "支付方式",
      transactionAmount: "交易金额",
      accountBalance: "账户余额",
      remarks: "备注",
      operator: "操作人",
      operationTime: "操作时间",
      recharge: "充值",
      deduction: "扣款",
      refund: "退款",
    },
    invoice: {
      workOrderNo: "工单号",
      search: "查询",
      reset: "重置",
      pleaseEnterWorkOrderNo: "请输入工单号",
      serialNo: "序号",
      invoiceNo: "发票号",
      platformOrderNo: "平台订单号",
      shippingAddress: "发货地",
      receivingAddress: "收货地",
      invoiceAmount: "发票金额",
      operation: "操作",
      view: "查看",
      closeDetails: "关闭详情",
    },
    recharge: {
      myWorkOrder: "我的工单",
      rechargeAmount: "充值金额",
      approvalStatus: "审核状态",
      time: "时间",
      search: "查询",
      reset: "重置",
      pleaseEnterRechargeAmount: "请输入充值金额",
      pleaseSelectApprovalStatus: "请选择审核状态",
      pendingApproval: "待审核",
      approved: "审核通过",
      rejected: "审核拒绝",
      to: "至",
      startDate: "开始日期",
      endDate: "结束日期",
      recharge: "充值",
      serialNo: "序号",
      amount: "金额",
      remitter: "汇款人",
      remittanceBank: "汇款银行",
      remittanceAccount: "汇款账号",
      wireTransferConfirmationNo: "电汇确认号",
      remittanceDate: "汇款日期",
      remark: "备注",
      file: "文件",
      applicationDate: "申请日期",
      operation: "操作",
      view: "查看",
      reasonForRejection: "拒绝原因",
      applyForRecharge: "申请充值",
      close: "关闭",
      addSuccess: "新增成功",
      editSuccess: "修改成功",
    },
    rechargeForm: {
      payeeInfo: "收款人信息",
      payeeName: "收款人姓名",
      payeeAddress: "收款人地址",
      accountNumber: "账号",
      payeeBank: "收款人开户行",
      routingNumber: "路由号码",
      remittanceCode: "汇款码",
      bankAddress: "银行地址",
      referenceDocument: "参考文献",
      replyInfo: "回复信息",
      submittedAmount: "提交金额",
      remitter: "汇款人",
      remittanceBank: "汇款银行",
      remittanceAccount: "汇款账号",
      wireTransferConfirmationNo: "电汇确认号",
      remittanceDate: "汇款日期",
      remark: "备注",
      businessLicense: "营业执照",
      save: "保存",
      pleaseEnterSubmittedAmount: "请输入提交金额",
      pleaseEnterRemitter: "请输入汇款人",
      pleaseEnterRemittanceBank: "请输入汇款银行",
      pleaseEnterRemittanceAccount: "请输入汇款账号",
      pleaseEnterWireTransferNo: "请输入电汇确认号",
      pleaseSelectRemittanceDate: "请选择汇款日期",
      uploadSizeLimit: "上传图片大小不能超过 10MB!",
      submitSuccess: "提交成功",
      submitFail: "提交失败",
    },
  },
  ltlnew: {
    list: {
      notificationList: "通知列表",
      notificationTime: "通知时间",
      search: "查询",
      reset: "重置",
      to: "至",
      startDate: "开始日期",
      endDate: "结束日期",
      serialNo: "序号",
      notificationTitle: "通知标题",
      operation: "操作",
      view: "查看",
      notificationDetails: "通知详情",
      close: "关闭",
    },
  },
  ltlorder: {
    list: {
      allOrders: "全部",
      pendingApproval: "待审核",
      approvalRejected: "审核拒绝",
      toBePicked: "待提货",
      inTransit: "运输中",
      delivered: "送达",
      orderCancelled: "订单取消",
      refused: "拒签",
      quantity: "数量",
    },
    place: {
      ltl: "零担",
      ftl: "整车",
      shippingManagement: "运输管理",
      switchTransportType: "切换运输类型",
    },
    result: {
      carrierQuoteResult: "报价的承运商结果",
      edit: "编辑",
      shippingAddress: "发货地址",
      receivingAddress: "收货地址",
      pickupDate: "取货日期",
      unit: "Unit",
      pkg: "Pkg",
      dimensions: "Dimensions",
      weightLb: "Weight(lb)",
      class: "Class",
      totalVolume: "TOTAL VOLUME(ft³)",
      totalWeightLb: "TOTAL WEIGHT(lb)",
      totalDensity: "TOTAL DENSITY(ft³)",
      sortBy: "排序依据",
      selectMethod: "选择方式",
      selectTime: "选择时间",
      priceAsc: "价格（从低到高）",
      transitTimeAsc: "运输时间（从低到高）",
      oneDay: "1天",
      twoDays: "2天",
      threeDays: "3天",
      fourDays: "4天",
      carriers: "运营商",
      pickupTime: "取件时间",
      estimatedTransitTime: "预估运输时间（工作日）",
      totalPrice: "总价",
      includingInsurance: "（含保险费：$ 0.00）",
      book: "预定",
      saveQuote: "保存报价",
      cost: "成本",
      description: "描述",
      amount: "金额",
      orderAmount: "订单金额",
      additionalFees: "额外费",
      compensationStandard: "赔付标准",
      truckingCompensation: "卡车公司赔偿金额",
      insuranceCompensation: "保险公司赔偿金额",
      day: "天",
    },
    orderView: {
      shipment: "货运",
      orderNumber: "订单号",
      pendingReview: "待审核",
      pendingPickup: "待提货",
      inTransit: "运输中",
      delivered: "已送达",
      getLabel: "获取面单",
      shippingLocation: "发货地",
      receivingLocation: "收货地",
      track: "轨迹",
      goods: "物品",
      freight: "运费",
      carrierInfo: "运营商信息",
      deductionReason: "扣款原因",
      deductionAmount: "扣款金额",
      certificateFile: "证明文件",
      operatorInfo: "操作人信息",
      addressName: "地址名称",
      addressType: "地址类型",
      address: "地址",
      contact: "联系",
      pickupTime: "取件时间",
      pickupCode: "取货码",
      specialService: "特殊服务",
      referenceNumber: "REF #",
      customerOrderNumber: "客户订单号",
      remarks: "备注",
      estimatedTransitTime: "预估运输时间（工作日）",
      deliveryCode: "交货码",
      estimatedDeliveryTime: "预计送达时间",
      commodityName: "物品名称",
      pieces: "件数",
      pkg: "包装",
      perUnit: "单单位尺寸",
      totalWeight: "总重量",
      class: "等级",
      declared: "申报价值",
      freightCost: "运费",
      orderAmount: "订单金额",
      insuranceFee: "保险费",
      subsidyAmount: "补贴金额",
      totalPrice: "总价",
      customFreightSystemCompany: "定制货运系统公司",
      origin: "始发地",
      destination: "目的地",
      noData: "暂无数据~",
      getSuccess: "获取成功",
      noLabel: "暂无面单",
    },
    orderlist: {
      platformOrderNo: "平台订单号",
      customerOrderNo: "客户订单号",
      search: "查询",
      reset: "重置",
      onlineQuote: "在线报价",
      serialNo: "序号",
      basicInfo: "基本信息",
      orderDetails: "订单详情",
      shippingInfo: "发货信息",
      orderInfo: "订单信息",
      operation: "操作",
      cancelOrder: "取消订单",
      copySuccess: "复制成功",
      confirmCancelOrder: "确定要取消订单？",
      warmTip: "温馨提示",
      createOrder: "创建订单",
      details: "详情",
      carrier: "承运商",
      status: "状态",
      mode: "模式",
      shippingTime: "发货时间",
      orderSource: "下单来源",
      orderFile: "订单文件",
      orderType: "订单类型",
      goodsInfo: "货物信息",
      specialService: "特殊服务",
      no: "无",
      freight: "运费",
      orderAmount: "订单金额",
      insuranceFee: "保险费",
      subsidyAmount: "补贴金额",
      totalPrice: "总价",
      website: "网站",
      ordinaryFile: "普通文件",
      toBeReviewed: "待审核",
      reviewRejected: "审核拒绝",
      pendingPickup: "待提货",
      inTransit: "运输中",
      delivered: "送达",
      orderCancelled: "订单取消",
      refused: "拒签",
      createTime: "创建时间",
      account: "账号",
      queryCode: "查询编码",
    },
    olPlace: {
      addressInfo: "地址信息",
      shippingAddress: "发货地址",
      addressType: "地址类型",
      receivingAddress: "收件地址",
      pickupDate: "取货日期",
      shippingInfo: "装运信息",
      howToFillSize: "如何正确的填写尺寸",
      selectProduct: "选择产品",
      parcelInfo: "包裹信息",
      commodityName: "商品名称",
      commodityQuantity: "商品数量",
      commodityUnit: "商品单位",
      palletQuantity: "打托数量",
      palletType: "打托类型",
      goodsValue: "货值",
      length: "长",
      width: "宽",
      height: "高",
      totalWeight: "总重量",
      grade: "等级",
      nmfcNumber: "NMFC编号",
      hazardousGoodsUN: "危险品UN编号",
      hazardousGoodsClass: "危险产品类别别号",
      hazardousGoodsQuantity: "危险品数量",
      isToxic: "是否有毒",
      emergencyContact: "紧急联系人",
      phoneNumber: "手机号",
      isHazardousGoods: "是否危险品",
      totalVolume: "总体积",
      totalDensity: "总密度",
      getQuote: "获取报价",
      pleaseSelectShippingAddress: "请选择发货地址",
      pleaseSelectAddressType: "请选择地址类型",
      pleaseSelectReceivingAddress: "请选择收件地址",
      pleaseSelectPickupDate: "请选择取货日期",
      pleaseEnterCommodityName: "请输入商品名称",
      pleaseEnterCommodityQuantity: "请输入商品数量",
      pleaseSelectCommodityUnit: "请选择商品单位",
      pleaseEnterPalletQuantity: "请输入打托数量",
      pleaseSelectPalletType: "请选择打托类型",
      pleaseEnterGoodsValue: "请输入货值",
      pleaseEnterLength: "请输入长",
      pleaseEnterWidth: "请输入宽",
      pleaseEnterHeight: "请输入高",
      pleaseEnterWeight: "请输入重量",
      pleaseEnterHazardousGoodsUN: "请输入危险品UN编号",
      pleaseSelectHazardousGoodsClass: "请选择危险产品类别别号",
      pleaseSelectIsToxic: "请选择是否有毒",
      pleaseEnterEmergencyContact: "请输入紧急联系人",
      pleaseEnterPhoneNumber: "请输入手机号",
      quoteSuccess: "获取报价成功",
      quoteFail: "获取报价失败",
    },
    zlPlace: {
      title: {
        addressInfo: "地址信息",
        shipmentInfo: "装运信息",
      },
      label: {
        originAddress: "发货地址",
        addressType: "地址类型",
        equipmentCategory: "设备类别",
        destinationAddress: "收件地址",
        pickupDate: "取货日期",
        commodityName: "商品名称",
        commodityQuantity: "商品数量",
        commodityUnit: "商品单位",
        palletQuantity: "打托数量",
        palletType: "打托类型",
        cargoValue: "货值",
        length: "长",
        width: "宽",
        height: "高",
        totalWeight: "总重量",
        grade: "等级",
        nmfc: "NMFC",
        hazmatUNNumber: "危险品UN编号",
        hazmatClass: "危险产品类别别号",
        hazmatQuantity: "危险品数量",
        isToxic: "是否有毒",
        emergencyContact: "紧急联系人",
        mobilePhone: "手机号",
        isHazmat: "是否危险品",
      },
      placeholder: {
        selectOriginAddress: "请选择发货地址",
        selectAddressType: "请选择地址类型",
        selectEquipmentCategory: "请选择设备类别",
        selectDestinationAddress: "请选择收件地址",
        selectPickupDate: "请选择取货日期",
      },
      options: {
        toxic: {
          nonToxic: "无毒",
          toxic: "有毒",
        },
      },
      unit: {
        inLb: "in/lb",
        cmKg: "cm/kg",
        volume: "ft³",
        weight: "lb",
        density: "lb/ft³",
        in: "in",
        cm: "cm",
        lb: "lb",
        kg: "kg",
      },
      button: {
        selectProduct: "选择产品",
        getQuote: "获取报价",
        reset: "重置",
      },
      packageInfo: "包裹信息",
      calculation: {
        totalVolume: "总体积",
        totalWeight: "总重量",
        totalDensity: "总密度",
      },
      validation: {
        selectOriginAddress: "请选择发货地址",
        selectAddressType: "请选择地址类型",
        selectDestinationAddress: "请选择收件地址",
        selectPickupDate: "请选择取货日期",
        enterCommodityName: "请输入商品名称",
        enterCommodityQuantity: "请输入商品数量",
        selectCommodityUnit: "请选择商品单位",
        enterPalletQuantity: "请输入打托数量",
        selectPalletType: "请选择打托类型",
        enterCargoValue: "请输入货值",
        enterLength: "请输入长",
        enterWidth: "请输入宽",
        enterHeight: "请输入高",
        enterWeight: "请输入重量",
        enterHazmatUNNumber: "请输入危险品UN编号",
        selectHazmatClass: "请选择危险产品类别别号",
        selectIsToxic: "请选择是否有毒",
        enterEmergencyContact: "请输入紧急联系人",
        enterMobilePhone: "请输入手机号",
      },
      message: {
        quoteSuccess: "获取报价成功",
        getQuoteFailed: "获取报价失败",
      },
    },
    order: {
      title: {
        shipperInfo: "发货信息",
        consigneeInfo: "收货信息",
        shipmentInfo: "装运信息",
        summary: "摘要",
        selectProduct: "选择产品",
      },
      label: {
        addressName: "地址名称",
        addressType: "地址类型",
        specialRequirements: "特殊需求",
        address1: "地址1",
        address2: "地址2",
        address3: "地址3",
        zipCode: "邮编",
        city: "城市",
        state: "州",
        country: "国家/地区",
        pickupCode: "取货码",
        pickupTimeSlot: "取货时间段",
        contactPerson: "联系人",
        contactPhone: "联系电话",
        contactEmail: "联系邮箱",
        orderNumber: "订单号",
        referenceNumber: "参考编号",
        remarks: "备注",
        deliveryCode: "交货码",
        deliveryTimeSlot: "交货时间段",
        commodityName: "商品名称",
        commodityQuantity: "商品数量",
        commodityUnit: "商品单位",
        palletQuantity: "打托数量",
        palletType: "打托类型",
        cargoValue: "货值",
        length: "长",
        width: "宽",
        height: "高",
        totalWeight: "总重量",
        grade: "等级",
        nmfc: "NMFC",
        hazmatUNNumber: "危险品UN编号",
        hazmatClass: "危险产品类别别号",
        hazmatQuantity: "危险品数量",
        isToxic: "是否有毒",
        emergencyContact: "紧急联系人",
        mobilePhone: "手机号",
        isHazmat: "是否危险品",
        packageInfo: "包裹信息",
        carrierPlatform: "承运平台",
        originLocation: "发货地",
        destinationLocation: "收货地",
        pickupDate: "取货日期",
        estimatedTransitTime: "预估运输时间(工作日)",
        totalPrice: "总价",
        paymentMethod: "支付方式",
        accountBalance: "账户余额",
      },
      placeholder: {
        enterAddressName: "请输入地址名称",
        selectAddressType: "请选择地址类型",
        selectSpecialRequirements: "请选择特殊需求",
        enterAddress1: "请输入地址1",
        enterAddress2: "请输入地址2",
        enterAddress3: "请输入地址3",
        enterZipCode: "请输入邮编",
        enterCity: "请输入城市",
        enterState: "请输入州",
        enterCountry: "请输入国家",
        enterPickupCode: "请输入取货码",
        startTime: "开始时间",
        endTime: "结束时间",
        enterContactPerson: "请输入联系人",
        enterContactPhone: "请输入联系电话",
        selectCountry: "请选择",
        enterContactEmail: "请输入联系邮箱",
        enterOrderNumber: "请输入订单号",
        enterReferenceNumber: "请输入参考编号",
        enterRemarks: "请输入备注",
        enterDeliveryCode: "请输入交货码",
        enterCommodityName: "请输入商品名称",
        enterCommodityQuantity: "请输入商品数量",
        selectCommodityUnit: "请选择商品单位",
        enterPalletQuantity: "请输入打托数量",
        selectPalletType: "请选择打托类型",
        enterCargoValue: "请输入货值",
        enterLength: "请输入长",
        enterWidth: "请输入宽",
        enterHeight: "请输入高",
        enterWeight: "请输入重量",
        enterHazmatUNNumber: "请输入危险品UN编号",
        selectHazmatClass: "请选择危险产品类别别号",
        selectIsToxic: "请选择是否有毒",
        enterEmergencyContact: "请输入紧急联系人",
        enterMobilePhone: "请输入手机号",
      },
      unit: {
        inLb: "in/lb",
        cmKg: "cm/kg",
        in: "in",
        cm: "cm",
        lb: "lb",
        kg: "kg",
        volume: "ft³",
        density: "lb/ft³",
        day: "天",
        currency: "$",
      },
      options: {
        toxic: {
          nonToxic: "无毒",
          toxic: "有毒",
        },
        country: {
          unitedStates: "United States",
        },
      },
      calculation: {
        totalVolume: "总体积",
        totalWeight: "总重量",
        totalDensity: "总密度",
      },
      button: {
        selectProduct: "选择产品",
        bookShipment: "预订发货",
        reestimate: "重新估价装运",
      },
      validation: {
        enterAddressName: "请输入地址名称",
        selectAddressType: "请选择地址类型",
        enterAddress1: "请输入地址1",
        enterCity: "请输入城市",
        selectPickupTimeSlot: "请选择取货时间段",
        enterPickupCode: "请输入取货码",
        enterContactPerson: "请输入联系人",
        enterContactPhone: "请输入联系电话",
        enterContactEmail: "请输入联系邮箱",
        enterOrderNumber: "请输入订单号",
        enterReferenceNumber: "请输入参考编号",
        enterRemarks: "请输入备注",
        enterDeliveryCode: "请输入交货码",
        selectDeliveryTimeSlot: "请选择交货时间段",
        enterCommodityName: "请输入商品名称",
        enterCommodityQuantity: "请输入商品数量",
        selectCommodityUnit: "请选择商品单位",
        enterPalletQuantity: "请输入打托数量",
        selectPalletType: "请选择打托类型",
        enterCargoValue: "请输入货值",
        enterLength: "请输入长",
        enterWidth: "请输入宽",
        enterHeight: "请输入高",
        enterWeight: "请输入重量",
        enterHazmatUNNumber: "请输入危险品UN编号",
        selectHazmatClass: "请选择危险产品类别别号",
        selectIsToxic: "请选择是否有毒",
        enterEmergencyContact: "请输入紧急联系人",
        enterMobilePhone: "请输入手机号",
      },
      message: {
        getQuoteFailed: "获取报价失败",
      },
    },
  },
};
